import { useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TaxTypePageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DeleteTaxTypeModal from 'modules/finance/components/DeleteTaxTypeModal'
import EditTaxTypeModal from 'modules/finance/components/EditTaxTypeModal'
import NewTaxTypeModal from 'modules/finance/components/NewTaxTypeModal'
import TaxTypeDatatable from 'modules/finance/components/TaxType/Datatable'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { LegalEntity } from './types'

export interface OutletContext {
  legalEntity?: LegalEntity
}

const TaxType = () => {
  const { navigation } = useNavigation()
  const location = useLocation()
  const navigate = useNavigate()
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false)

  const [showEditModal, setShowEditModal] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [selectedTaxTypeId, setSelectedTaxTypeId] = useState<string | null>(null)

  const { data: page, loading, error } = useQuery(TaxTypePageDocument)

  const canManageTaxTypes =
    page?.finance?._policies?.settingsSeeAccountingSettingsTaxTypes?.can ?? false
  const legalEntities = page?.companies?.legalEntities ?? []
  const seePurchaseLedgerAccounts =
    page?.finance._policies?.accountingSeePurchaseAccounts?.can ?? false
  const seeSalesLedgerAccounts = page?.finance._policies?.accountingSeeSalesAccounts?.can ?? false

  const showshowEditModaForTaxTypeIdDetail = (id: string) => {
    setSelectedTaxTypeId(id)
    setShowEditModal(true)
  }

  const showDeleteModalForTaxTypeId = (id: string) => {
    setSelectedTaxTypeId(id)
    setShowDeleteModal(true)
  }

  const showDetail = (id: string) => {
    navigate(
      navigation.settings.finance.accounting.taxType.taxTypeId.fullPath({
        id: id,
      })
    )
  }

  const showingTaxPage = location.pathname.endsWith('tax')

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      authorized={canManageTaxTypes}
      showHeader={showingTaxPage}
    >
      {showingTaxPage && (
        <Box height="full">
          <TaxTypeDatatable
            showDetailTaxType={showDetail}
            showEditTaxType={showshowEditModaForTaxTypeIdDetail}
            showDeleteTaxType={showDeleteModalForTaxTypeId}
            onNewTaxTypeClick={() => setShowCreateModal(true)}
          />

          {showCreateModal && (
            <NewTaxTypeModal
              legalEntities={legalEntities}
              onClose={() => setShowCreateModal(false)}
              seePurchaseLedgerAccounts={seePurchaseLedgerAccounts}
              seeSalesLedgerAccounts={seeSalesLedgerAccounts}
            />
          )}
          {showEditModal && selectedTaxTypeId && (
            <EditTaxTypeModal
              taxTypeId={selectedTaxTypeId}
              legalEntities={legalEntities}
              onClose={() => setShowEditModal(false)}
              seePurchaseLedgerAccounts={seePurchaseLedgerAccounts}
              seeSalesLedgerAccounts={seeSalesLedgerAccounts}
            />
          )}
          {showDeleteModal && selectedTaxTypeId && (
            <DeleteTaxTypeModal id={selectedTaxTypeId} onClose={() => setShowDeleteModal(false)} />
          )}
        </Box>
      )}
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default TaxType
